import { useCallback } from 'react'
import * as React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import UpdateItemOrTripDatesModal from './UpdateItemOrTripDatesModal'
import { useItemOutsideOfTripDates } from './utils'

import SolidExclamationTriangleIcon from 'LuxKit/Icons/solid/SolidExclamationTriangleIcon'
import Tooltip from 'LuxKit/Tooltip'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'
import useCanEditTrip from 'tripPlanner/hooks/useCanEditTrip'
import type { TripItem } from 'tripPlanner/types/tripItem'
import Clickable from 'components/Common/Clickable'

const FlexClickable = styled(Clickable)`
  display: flex;
`

interface Props {
  item: TripItem
  changeItemDates: () => void
}
export default function OutsideTripDatesIcon({ item, changeItemDates }: Props) {
  const intl = useIntl()
  const openModal = useOpenModal()
  const canEdit = useCanEditTrip()
  const updateItemOrTripDates = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      openModal(UpdateItemOrTripDatesModal, {
        item: item as TripItem & { startDate: moment.Moment },
        changeItemDates,
      })
      e.stopPropagation()
    },
    [changeItemDates, item, openModal],
  )

  const isItemOutsideOfTripDates: boolean = useItemOutsideOfTripDates(item)
  if (!canEdit || !isItemOutsideOfTripDates) return null

  const tooltipDescription = intl.formatMessage({
    id: 'AKSsQ1UkiRMWkS4PKWft',
    defaultMessage: 'Click here to view date conflict',
    description: 'Tooltip for the date conflict warning icon on trip planner itinerary items',
  })

  return (
    <Tooltip description={tooltipDescription}>
      <FlexClickable onClick={updateItemOrTripDates}>
        <SolidExclamationTriangleIcon size="S" colour="warning" />
      </FlexClickable>
    </Tooltip>
  )
}
